/**
 * This package should define custom analytics events and wrappers for google analytics APIs
 * No google analytics event should be invoked directly from any other code.
 * It should go via AnalyticsUtil.
 */
import { logEvent } from "firebase/analytics";
import {analytics} from '../firebase'

/**
 * Logs event on screen change
 * @param {*} currentScreenName current screen name e.g. Care
 */
export const logEventOnScreenChange = currentScreenName => {
    logEvent(analytics, 'screen_view', {
        screen_path: currentScreenName,
    });
};

/**
 * Logs event on component render
 * @param {*} name current component name e.g. Care
 */
export const logEventOnComponentRendered = name => {
    logEvent(analytics, 'component_render', {
        name: name,
    });
};

/**
 * Logs event on button press
 * @param {*} category specifies the event category e.g. onPress
 * @param {*} label specifies button label e.g. Signup
 */
export const logEventOnPress = (category, label, value) => {
    logEvent(analytics, category, {
        label: label,
        value: value,
    });
};

/**
 * Logs event on show modal(pop ups)
 * @param {*} modalName specifies modal name
 */
export const logEventOnShowModal = (modalName) => {
    logEvent(analytics, 'modal_view', {
        modal_name: modalName,
    });
};

/**
 * set user properties
 * @param {*} userId specifies the logged in users ID  
 * @param {*} branch specifies the logged in users branch  
 * @param {*} agency specifies the logged in users agency  
 * **/
export const logUserSessionAndProperties = (id, branch, agency) => {
    analytics.setUserId(id);
    analytics.setUserProperty('branch', branch);
    analytics.setUserProperty('agency', agency);
};
  
export const logEventOnUserLoggedIn = () => {
    analytics().logEvent('logged_in_user', {});
};
  
export const logEventOnUserSignup = () => {
    analytics().logEvent('signed_up_user', {});
};
/**
 * Logs an error event to Firebase Analytics
 * @param {string} errorMessage - The error message to log
 * @param {string} location - The screen or component where the error occurred (optional)
 */
export const logErrorEvent = (errorMessage, location = 'unknown') => {
    logEvent(analytics, 'error', {
        message: errorMessage,
        screen: location,
    });
};